import React from 'react';

import styles from './styles/styles.module.scss';

const backgroundPlaceholderColors = [
  'rgba(123,164,216,1)',
  'rgba(101,96,92,1)',
  'rgba(146,146,108,1)',
  'rgba(95,132,184,1)',
  'rgba(202,139,91,1)',
  'rgba(83,98,191,1)',
  'rgba(108,139,133,1)',
  'rgba(25,168,59,1)'
];

export function getBgColor(string) {
  let i = 0;
  if (string) {
    i = string.length;
  }
  let charSum = 0;
  while (i--) {
    charSum += string.charCodeAt(i);
  }
  const backgroundColorIdx = charSum % backgroundPlaceholderColors.length;
  return backgroundPlaceholderColors[backgroundColorIdx];
}

export function getBgImg(url = null, noBackground = false) {
  if (url && noBackground) {
    return `url(${url})`;
  }
  let backgroundImage = 'linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0px, rgba(0, 0, 0, 0) 70px, rgba(0, 0, 0, 0) 100%)';
  if (url) {
    backgroundImage += `, url(${url})`;
  }
  return backgroundImage;
}

export function getImgDefaultStyle(string, backgroundImage) {
  return {
    backgroundColor: getBgColor(string),
    backgroundImage,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover'
  };
}

export default function CardImage({ className, url, title, darker, lazyload = true, onClick, noBackground = false }) {
  const classes = ['xlate-none'];
  if (lazyload) {
    classes.push('lazyload');
  }
  if (className) {
    classes.push(className);
  }
  if (darker) {
    classes.push(styles.darker);
  }
  return (
    <div
      aria-label={title}
      className={classes.join(' ')}
      data-bg={lazyload ? getBgImg(url, noBackground) : null}
      role="img"
      style={getImgDefaultStyle(title, getBgImg(lazyload ? null : url, noBackground))}
      title={title}
      onClick={onClick}
    />
  );
}
